<template>
  <ValidationObserver v-slot="{ failed, valid, invalid, validated, passes, validate, handleSubmit, errors }"
                      ref="observer">
    <v-snackbar
        v-model="failed"
        color="rgb(244, 67, 54)"
        outlined
        timeout="8000"
    >
      {{ $t('validation.errors') }}
      <!--			<template v-slot:action="{ attrs }">-->
      <!--				<v-btn-->
      <!--					text-->
      <!--					v-bind="attrs"-->
      <!--					@click="failed = false"-->
      <!--				>-->
      <!--					X-->
      <!--				</v-btn>-->
      <!--			</template>-->
    </v-snackbar>
    <div class="fill-height pa-5 pa-sm-10" v-if="AppStore.started_app" id="comment-page">
      <v-container class="fill-height d-flex align-center flex-row">
        <v-row class="">
          <v-card elevation="0" class="mx-auto pa-1 pa-sm-10 mb-5" rounded="xl">

            <v-col cols="12" class="text-h2 pt-5 pb-7 text-center" id="comment-title"
                   v-html="AppStore.data.configuration[AppStore.locale].comment_title">
            </v-col>

            <v-col cols="12 text-center"
                   v-if="helpTextOverride || AppStore.data.configuration[AppStore.locale].comment_help">
              <div id="comment-help"
                   v-html="helpTextOverride || AppStore.data.configuration[AppStore.locale].comment_help"
                   :style="'color:'+AppStore.data.general.secondary_color.hexa"></div>
            </v-col>
            <v-col cols="12" v-if="AppStore.data.configuration.display_mic_btn">
              <section>
                <div id="mic-btn" :class="{ active: isRecording}" @click="toggleMic"
                     :style="isRecording ? 'background-color:'+AppStore.data.general.primary_color.hexa : ''">
									<span
                      v-html="isCountingDown ? countdownValue : (isRecording ?  AppStore.data.configuration[AppStore.locale].mic_btn_text_stop : AppStore.data.configuration[AppStore.locale].mic_btn_text)"
                      style="font-size: 35px;"></span>
                  <span style="--i:0;"></span>
                  <span style="--i:1;"></span>
                  <span style="--i:2;"></span>
                  <span style="--i:3;"></span>

                </div>
              </section>
            </v-col>

            <v-col cols="12" class="">
              <input
                  type="text"
                  v-autowidth="{maxWidth: '960px', minWidth: '20px', comfortZone: 0}"
                  class="openKeyboardBtn text-button mb-5"
                  @click="$refs.comment.focus(); outlinedTextArea = true"
                  :style="'border-color:'+AppStore.data.general.primary_color.hexa+';background-color:'+AppStore.data.general.primary_color.hexa"
                  :placeholder="AppStore.data.configuration[AppStore.locale].comment_keyboard_btn_text"
                  v-if="AppStore.data.configuration[AppStore.locale].comment_keyboard_btn_text && !outlinedTextArea && !AppStore.data.configuration.display_mic_btn"
              />

              <ValidationProvider name="comment" :rules="commentRules" v-slot="{ errors }">
                <v-textarea
                    v-model="AppStore.rating.comment"
                    :error-messages="errors"
                    :placeholder="_.includes([0,1,2], AppStore.rating.rate) ? AppStore.data.configuration[AppStore.locale].comment_negative_placeholder : AppStore.data.configuration[AppStore.locale].comment_positive_placeholder"
                    persistent-placeholder
                    outlined
                    @focus="outlinedTextArea = true; commentFieldFocus = true"
                    ref="comment"
                    id="comment-textarea"
                    rows="9"
                    auto-grow
                    @input="getCommentRule()"
                    persistent-hint
                    class="mb-3"
                    name="comment">
                </v-textarea>
              </ValidationProvider>

            </v-col>
            <v-col cols="12" id="comment-questions"
                   v-if="questions_to_display && questions_to_display.length">
              <div v-for="(question, questionIndex) in questions_to_display"
                   :key="questions_to_display[questionIndex].id+AppStore.updatedKey" class="question-question">
                <divider-view v-if="question.format === 'divider'"></divider-view>
                <slider-view v-if="question.format === 'slider' && !questions_to_display[questionIndex].must_be_hide"
                             :rules="question.is_required ? { regex: /^[1-5]+$/ } : ''"
                             v-model="questions_to_display[questionIndex]"
                             :id="'q'+questions_to_display[questionIndex].id"
                             :questionIndex="questionIndex" :lang="AppStore.locale"></slider-view>
                <text-view v-if="question.format === 'text' && !questions_to_display[questionIndex].must_be_hide"
                           :rules="question.regex ? question.is_required ? 'required|regex:'+question.regex : 'regex:'+question.regex : question.is_required ? 'required' : ''"
                           v-model="questions_to_display[questionIndex]"
                           :id="'q'+questions_to_display[questionIndex].id"
                           :questionIndex="questionIndex" :lang="AppStore.locale"></text-view>
                <textarea-view
                    v-if="question.format === 'textarea' && !questions_to_display[questionIndex].must_be_hide"
                    :rules="question.is_required ? 'required' : ''"
                    v-model="questions_to_display[questionIndex]"
                    :id="'q'+questions_to_display[questionIndex].id"
                    :questionIndex="questionIndex" :lang="AppStore.locale"></textarea-view>
                <select-view v-if="question.format === 'select' && !questions_to_display[questionIndex].must_be_hide"
                             :rules="question.is_required ? 'required' : ''"
                             return-object
                             :id="'q'+questions_to_display[questionIndex].id"
                             :name="questions_to_display[questionIndex].name"
                             v-model="questions_to_display[questionIndex]"
                             :questionIndex="questionIndex" :lang="AppStore.locale"></select-view>
                <checkbox-view
                    v-if="question.format === 'checkbox' && !questions_to_display[questionIndex].must_be_hide"
                    :rules="question.is_required ? 'required' : ''"
                    :color="AppStore.data.general.primary_color"
                    :id="'q'+questions_to_display[questionIndex].id"
                    v-model="questions_to_display[questionIndex]"
                    :questionIndex="questionIndex" :lang="AppStore.locale"></checkbox-view>
                <radio-view v-if="question.format === 'radio' && !questions_to_display[questionIndex].must_be_hide"
                            :rules="question.is_required ? 'required' : ''"
                            :color="AppStore.data.general.primary_color"
                            :id="'q'+questions_to_display[questionIndex].id"
                            v-model="questions_to_display[questionIndex]"
                            :questionIndex="questionIndex" :lang="AppStore.locale"></radio-view>
                <switch-view v-if="question.format === 'switch' && !questions_to_display[questionIndex].must_be_hide"
                             :rules="question.is_required ? 'required' : ''"
                             :color="AppStore.data.general.primary_color"
                             :id="'q'+questions_to_display[questionIndex].id"
                             v-model="questions_to_display[questionIndex]"
                             :questionIndex="questionIndex" :lang="AppStore.locale"></switch-view>
              </div>
            </v-col>

            <v-col cols="12" class="text-center">
              <!--							<v-btn-->
              <!--								v-if="AppStore.rating.comment.trim().length < AppStore.data.configuration.comment_chars_required_number"-->
              <!--								@click="passes(submit)" rounded-->
              <!--								outlined elevation="0"-->
              <!--								:large="AppStore.data.general.button_size === 'large'"-->
              <!--								:x-large="AppStore.data.general.button_size === 'x-large'"-->
              <!--								:x-small="AppStore.data.general.button_size === 'x-small'"-->
              <!--								:small="AppStore.data.general.button_size === 'small'"-->
              <!--								:color="AppStore.data.general.primary_color.hexa" class="revert-btn text-button"-->
              <!--								:style="Helpers.getButtonSize(AppStore.data.general.button_size)"-->
              <!--								v-html="AppStore.data.configuration[AppStore.locale].comment_retry_btn_text">-->
              <!--							</v-btn>-->
              <v-btn
                  @click="passes(submit)" rounded elevation="0" dark
                  :large="AppStore.data.general.button_size === 'large'"
                  :x-large="AppStore.data.general.button_size === 'x-large'"
                  :x-small="AppStore.data.general.button_size === 'x-small'"
                  :small="AppStore.data.general.button_size === 'small'"
                  @keypress.enter="navigate"
                  class="text-button"
                  :color="AppStore.data.general.primary_color.hexa"
                  :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
                  v-html="AppStore.data.configuration[AppStore.locale].comment_validate_btn_text">
              </v-btn>
            </v-col>
          </v-card>
        </v-row>
      </v-container>
    </div>
  </ValidationObserver>

</template>

<script>
import VTextAreaWithValidation from "../../../components/communs/inputs/VTextAreaWithValidation.vue";
import AppStore from "../../../stores/AppStore";
import _ from 'lodash';
import VueInputAutowidth from 'vue-input-autowidth'
import Vue from "vue";
import Stepper from "../../../components/communs/Stepper.vue";
import {EventBus} from "../../../services/Request";
import Helpers from "../../../services/Helpers";
import TextareaView from "../../../components/communs/inputViewer3/TextareaView.vue";
import TextView from "../../../components/communs/inputViewer3/TextView.vue";
import SliderView from "../../../components/communs/inputViewer3/SliderView.vue";
import SwitchView from "../../../components/communs/inputViewer3/SwitchView.vue";
import DividerView from "../../../components/communs/inputViewer3/DividerView.vue";
import CheckboxView from "../../../components/communs/inputViewer3/CheckboxView.vue";
import RadioView from "../../../components/communs/inputViewer3/RadioView.vue";
import SelectView from "../../../components/communs/inputViewer3/SelectView.vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";

Vue.use(VueInputAutowidth)
export default {
  name: 'comment-view',

  components: {
    ValidationObserver, ValidationProvider,
    SelectView, RadioView, CheckboxView, DividerView, SwitchView, SliderView, TextView, TextareaView,
    VTextAreaWithValidation,
    Stepper
  },

  props: {},

  data: () => ({
    AppStore,
    commentRules: '',
    outlinedTextArea: false,
    questions: [],
    questions_to_display: [],
    commentFieldFocus: false,

    // Speech recognition state
    isRecording: false,
    isCountingDown: false,
    countdownValue: 3,
    countdownTimer: null,
    pauseTimer: null,
    recognition: null,
    helpTextOverride: null,
    
    // Text management - clean approach
    initialComment: '', // Comment content before starting mic
    currentTranscript: '', // Current accumulated transcript from this mic session
  }),

  created() {
    EventBus.$on('updateQuestion', (data) => {
      const index = _.findIndex(this.questions_to_display, (q) => {
        return q.id === data.question.id;
      }, 0)
      if (index !== -1) {
        let newQuestionToDisplay = Object.assign([], this.questions_to_display)
        newQuestionToDisplay[index] = data.question
        this.questions_to_display = newQuestionToDisplay
      }
    });
  },

  async mounted() {
    this.questions = []
    this.questions_to_display = []
    await this.getBookmarkedQuestions()
    if (AppStore.questions_by_page[3] && AppStore.questions_by_page[3].length > AppStore.data.configuration.questions_to_display_3) {
      await this.getRandomQuestions();
    } else {
      this.questions = Object.assign([], _.filter(AppStore.questions_by_page[3], (q) => {
        return !q.is_bookmarked
      }))
      this.questions_to_display = this.questions_to_display.concat(this.questions)
    }
  },

  computed: {
    Helpers() {
      return Helpers
    },
    _() {
      return _;
    }
  },

  watch: {
    questions_to_display: {
      handler(val) {
        this.$set(this.AppStore.questions_displayed_by_page, 3, val);
      },
      deep: true
    }
  },

  methods: {
    toggleMic() {
      if (this.isCountingDown) {
        this.cancelCountdown();
        return;
      }
      
      if (this.isRecording) {
        this.stopRecording('manual');
      } else {
        // Detect iOS/iPad (Safari requirement: skip countdown)
        const isIOS = (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 0) || navigator.userAgent.includes("iPad");
        
        if (isIOS) {
          // iOS: Launch mic immediately (no countdown) - INLINE to stay in gesture context
          this.helpTextOverride = this.$t('helpTextOverride.speak');
          
          // Check browser support
          if (!('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
            console.error('Speech recognition not supported');
            this.helpTextOverride = null;
            // Optionally: Show a user-friendly message here, e.g., via a toast
            return;
          }
          
          this.isRecording = true;
          AppStore.rating.voice_transcript = true;
          
          // Save the current comment content (if any) before starting
          this.initialComment = AppStore.rating.comment ? AppStore.rating.comment.trim() : '';
          this.currentTranscript = '';
          
          // Clear any existing pause timer
          if (this.pauseTimer) {
            clearTimeout(this.pauseTimer);
            this.pauseTimer = null;
          }
          
          // Create and start recognition INLINE (must be synchronous with click)
          this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
          this.recognition.continuous = true;
          this.recognition.interimResults = true;
          this.recognition.lang = 'fr-FR';
          
          this.recognition.onend = () => {
            console.log('Recognition ended');
            if (this.isRecording) {
              this.stopRecording('ended');
            }
            this.recognition = null;
          };
          
          this.recognition.onerror = (event) => {
            console.error('Speech recognition error:', event.error);
            if (this.isRecording) this.stopRecording('error');
          };
          
          this.recognition.onresult = (event) => {
            if (this.pauseTimer) {
              clearTimeout(this.pauseTimer);
              this.pauseTimer = null;
            }
            
            let newFinalTranscript = '';
            let interimTranscript = '';
            
            for (let i = event.resultIndex; i < event.results.length; i++) {
              const transcript = event.results[i][0].transcript;
              if (event.results[i].isFinal) {
                newFinalTranscript += transcript + ' ';
              } else {
                interimTranscript += transcript;
              }
            }
            
            if (newFinalTranscript) {
              newFinalTranscript = newFinalTranscript.trim();
              let current = this.currentTranscript ? this.currentTranscript.trim() : '';
              
              if (current.length > 0 && newFinalTranscript.length > 0) {
                 const cNorm = current.toLowerCase();
                 const nNorm = newFinalTranscript.toLowerCase();
                 
                 let overlapLength = 0;
                 const maxLen = Math.min(cNorm.length, nNorm.length);
                 
                 for (let len = maxLen; len > 0; len--) {
                     const suffix = cNorm.slice(-len);
                     const prefix = nNorm.slice(0, len);
                     
                     if (suffix === prefix) {
                         overlapLength = len;
                         break; 
                     }
                 }
                 
                 if (overlapLength > 0) {
                     const realNew = newFinalTranscript.slice(overlapLength).trim();
                     if (realNew) {
                       this.currentTranscript = current + ' ' + realNew;
                     }
                 } else {
                     this.currentTranscript = current + ' ' + newFinalTranscript;
                 }
              } else {
                  if (current) {
                     this.currentTranscript = current + ' ' + newFinalTranscript;
                  } else {
                     this.currentTranscript = newFinalTranscript;
                  }
              }
            }
            
            let displayText = '';
            if (this.initialComment) {
              displayText = this.initialComment;
            }
            
            const transcriptToShow = this.currentTranscript + (interimTranscript ? ' ' + interimTranscript : '');
            if (transcriptToShow) {
              if (displayText) {
                displayText += ' ' + this.capitalizeFirstLetter(transcriptToShow);
              } else {
                displayText = this.capitalizeFirstLetter(transcriptToShow);
              }
            }
            
            AppStore.rating.comment = displayText;
            
            this.pauseTimer = setTimeout(() => {
              this.stopRecording('pause');
            }, 3000);
          };
          
          try {
            this.recognition.start();
          } catch (e) {
            console.error('Error starting recognition:', e);
            this.isRecording = false;
            this.helpTextOverride = null;
          }
        } else {
          // Android/Lenovo: Use countdown
          this.startCountdown();
        }
      }
    },
    
    startCountdown() {
      this.isCountingDown = true;
      this.countdownValue = 3;
      this.helpTextOverride = this.$t('helpTextOverride.prepare');
      
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      
      this.countdownTimer = setInterval(() => {
        this.countdownValue--;
        if (this.countdownValue <= 0) {
          clearInterval(this.countdownTimer);
          this.isCountingDown = false;
          this.helpTextOverride = this.$t('helpTextOverride.speak');
          this.startRecording();
        }
      }, 1000);
    },
    
    cancelCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.isCountingDown = false;
      this.helpTextOverride = null;
    },
    
    startRecording() {
      // Check browser support
      if (!('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
        console.error('Speech recognition not supported');
        this.helpTextOverride = null;
        return;
      }
      
      this.isRecording = true;
      AppStore.rating.voice_transcript = true;
      
      // Save the current comment content (if any) before starting
      this.initialComment = AppStore.rating.comment ? AppStore.rating.comment.trim() : '';
      this.currentTranscript = '';
      
      // Clear any existing pause timer
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer);
        this.pauseTimer = null;
      }
      
      // Create and start recognition
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'fr-FR';
      
      this.recognition.onend = () => {
        // If still recording, the recognition stopped unexpectedly — just stop gracefully
        if (this.isRecording) {
          this.stopRecording('ended');
        }
        this.recognition = null;
      };
      
      this.recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        if (this.isRecording) this.stopRecording('error');
      };
      
      this.recognition.onresult = (event) => {
        // Clear the pause timer on every result
        if (this.pauseTimer) {
          clearTimeout(this.pauseTimer);
          this.pauseTimer = null;
        }
        
        // ANDROID FIX: Robust Deduplication Logic (Overlap Detection)
        let newFinalTranscript = '';
        let interimTranscript = '';
        
        // 1. Gather all potential new final content
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            newFinalTranscript += transcript + ' ';
          } else {
            interimTranscript += transcript;
          }
        }
        
        // 2. Intelligent deduplication (Overlap Check)
        if (newFinalTranscript) {
          newFinalTranscript = newFinalTranscript.trim();
          let current = this.currentTranscript ? this.currentTranscript.trim() : '';
          
          if (current.length > 0 && newFinalTranscript.length > 0) {
             const cNorm = current.toLowerCase();
             const nNorm = newFinalTranscript.toLowerCase();
             
             let overlapLength = 0;
             const maxLen = Math.min(cNorm.length, nNorm.length);
             
             for (let len = maxLen; len > 0; len--) {
                 const suffix = cNorm.slice(-len);
                 const prefix = nNorm.slice(0, len);
                 
                 if (suffix === prefix) {
                     overlapLength = len;
                     break; 
                 }
             }
             
             if (overlapLength > 0) {
                 const realNew = newFinalTranscript.slice(overlapLength).trim();
                 if (realNew) {
                   this.currentTranscript = current + ' ' + realNew;
                 }
             } else {
                 this.currentTranscript = current + ' ' + newFinalTranscript;
             }
          } else {
              if (current) {
                 this.currentTranscript = current + ' ' + newFinalTranscript;
              } else {
                 this.currentTranscript = newFinalTranscript;
              }
          }
        }
        
        // Combine initial comment + accumulated final transcript + interim transcript
        let displayText = '';
        if (this.initialComment) {
          displayText = this.initialComment;
        }
        
        const transcriptToShow = this.currentTranscript + (interimTranscript ? ' ' + interimTranscript : '');
        if (transcriptToShow) {
          if (displayText) {
            displayText += ' ' + this.capitalizeFirstLetter(transcriptToShow);
          } else {
            displayText = this.capitalizeFirstLetter(transcriptToShow);
          }
        }
        
        // Update the comment field
        AppStore.rating.comment = displayText;
        
        // Start pause timer after final result (3 seconds of silence = stop)
        this.pauseTimer = setTimeout(() => {
          this.stopRecording('pause');
        }, 3000);
      };
      
      try {
        this.recognition.start();
      } catch (e) {
        console.error('Error starting recognition:', e);
        this.isRecording = false;
        this.helpTextOverride = null;
      }
    },
    
    stopRecording(reason) {
      if (!this.isRecording) {
        return; // Already stopped
      }
      
      this.isRecording = false;
      this.helpTextOverride = null;
      
      // Clear pause timer
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer);
        this.pauseTimer = null;
      }
      
      // Stop recognition
      if (this.recognition) {
        try {
          this.recognition.stop();
        } catch (e) {
          // ignore
        }
      }
      
      // Format the final text: capitalize first letter and add period
      if (AppStore.rating.comment) {
        let finalText = AppStore.rating.comment.trim();
        
        // Capitalize first letter
        finalText = this.capitalizeFirstLetter(finalText);
        
        // Add period at the end if not already present
        if (finalText && !finalText.match(/[.!?]$/)) {
          finalText += '.';
        }
        
        AppStore.rating.comment = finalText;
      }
    },
    
    capitalizeFirstLetter(text) {
      if (!text) return text;
      // Capitalize first letter and after ". ", "! ", "? "
      return text.replace(/(^|[.!?]\s+)([a-z])/g, (match, separator, letter) => {
        return separator + letter.toUpperCase();
      });
    },
    
    getBookmarkedQuestions() {
      this.questions_to_display = Object.assign([], AppStore.bookmarkedQuestions[3])
    },

    getRandomQuestions() {
      const max = AppStore.data.configuration.questions_to_display_3 - this.questions_to_display.length
      this.questions = Object.assign([], _.filter(AppStore.questions_by_page[3], (q) => {
        return !q.is_bookmarked
      }))

      for (let i = 0; i < max; i++) {
        const randomQuestionIndex = Math.floor(Math.random() * (this.questions.length));
        this.questions_to_display.push(this.questions[randomQuestionIndex]);
        this.questions.splice(randomQuestionIndex, 1)
      }
    },
    submit() {
      this.commentFieldFocus = false
      if (AppStore.data.configuration.skip_questions_page && !AppStore.data.configuration.skip_timeline_page) {
        EventBus.$emit('storeRating', 'noReset')
        this.$router.push({name: 'tb-3-timeline'})
      } else if (AppStore.data.configuration.skip_questions_page && AppStore.data.configuration.skip_timeline_page) {
        EventBus.$emit('storeRating', 'noReset')
        this.$router.push({name: 'tb-3-home'})
      } else {
        this.$router.push({name: 'tb-3-questions'})
      }
    },

    getCommentRule() {
      if (AppStore.rating.comment.length > 0 && AppStore.data.configuration.comment_chars_required_number > 0) {
        this.commentRules = 'required|min:' + AppStore.data.configuration.comment_chars_required_number
      } else {
        this.commentRules = ''
      }
    }
  }
};
</script>
<style scoped lang="scss">
.openKeyboardBtn {
  margin: 0 auto;
  display: block;
  min-width: 64px;
  height: 44px;
  padding: 0 16px;
  background-color: rgb(252, 119, 83);
  border-color: rgb(252, 119, 83);
  font-size: 1.2rem;
  color: white !important;
  border-radius: 28px;
  caret-color: transparent;
  font-weight: 700;
  letter-spacing: 0.0892857143em;
  justify-content: center;
  outline: 0;
  position: relative;
  text-decoration: none;
  text-indent: 0.0892857143em;
  text-transform: uppercase;
  transition-duration: 0.28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
}

.openKeyboardBtn::placeholder {
  color: white !important;
}

//Mic
section {
  display: flex;
  justify-content: center;
  align-items: center;
  //min-height: 70px;
  //animation: colorAnimate 8s linear infinite;
}

//@keyframes colorAnimate {
//	100% {
//		filter: hue-rotate(360deg)
//	}
//}

#mic-btn {
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

#mic-btn span:first-child {
  position: absolute;
  width: 70px;
  height: 70px;
  text-align: center;
  background: inherit;
  border-radius: inherit;
  z-index: 1000;
  align-content: center;
}

.active span:first-child {

}

.active span:not(:first-child) {
  position: absolute;
  width: 70px;
  height: 70px;
  background: inherit;
  border-radius: inherit;
  opacity: .8;
  animation: pulseAnimate 4s ease-out infinite;
  animation-delay: calc(1s * var(--i));
}

@keyframes pulseAnimate {
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
</style>
